import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const KSeFSettingsPage = lazy(
  () => import("../../../../components/WMS/KSeF/KSeFSettingsPage.tsx"),
)

export const Route = createFileRoute("/_layout/WMS/ksef/settings")({
  component: KSeFSettingsRoute,
})

function KSeFSettingsRoute() {
  return (
    <LazyRoutePage>
      <KSeFSettingsPage />
    </LazyRoutePage>
  )
}
